import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ReviewReactionOptions } from '@uc/web/shared/data-models';
import {
	Reaction,
	ReactionType,
	ReviewReaction,
} from '../../../models/university-reviews.models';
import {
	ThumbsDownOutlineSvgComponent,
	ThumbsDownSolidSvgComponent,
	ThumbsUpOutlineSvgComponent,
	ThumbsUpSolidSvgComponent,
} from '@uc/shared/svg';

@Component({
	selector: 'uc-review-reaction',
	templateUrl: './review-reaction.component.html',
	imports: [
		ThumbsUpOutlineSvgComponent,
		ThumbsUpSolidSvgComponent,
		ThumbsDownOutlineSvgComponent,
		ThumbsDownSolidSvgComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewReactionComponent {
	reviewId = input.required<number>();
	reaction = input<ReviewReactionOptions>();
	likes = input<number>();
	dislikes = input<number>();
	reviewReaction = output<ReviewReaction>();

	protected react = Reaction;

	onReviewReaction(reaction: ReactionType, reviewId: number) {
		this.reviewReaction.emit({ reaction, reviewId });
	}
}
